import { render, staticRenderFns } from "./StatisticEcharts.vue?vue&type=template&id=4b496240&scoped=true&"
import script from "./StatisticEcharts.vue?vue&type=script&lang=ts&"
export * from "./StatisticEcharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b496240",
  null
  
)

export default component.exports